import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { UpdateCasosUsoRequest } from '@models/seguridad/casosUso/updateCasosUsoRequest.model';
import { MenuDto } from '@models/seguridad/menu/menuDto.model';
import { CasoUsoService } from '@services/casoUso/casoUso.service';
import { MenuService } from '@services/menu/menu.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { isFalsy } from 'utility-types';
import { ButtonSaveComponent } from "../../../../../component/button-save/button-save.component";
import { ButtonCancelDialogComponent } from "../../../../../component/button-cancel-dialog/button-cancel-dialog.component";

@Component({
  standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, AppRolesDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatIconModule,ButtonCancelDialogComponent,
    NgxSpinnerModule, ButtonSaveComponent, ButtonCloseDialogComponent, ButtonCancelDialogComponent],
  selector: 'app-dialog-update-caso-uso',
  templateUrl: './dialog-update-caso-uso.component.html',
  styleUrls: ['./dialog-update-caso-uso.component.css']
})
export class DialogUpdateCasoUsoComponent implements OnInit {

   formBuilder = new FormBuilder;
    form: any;
    menus!: MenuDto[];
    casoUsoDto!:CasoUsoDto;
    get f() { return this.form.controls; }

    constructor(
      public dialogRef: MatDialogRef<DialogUpdateCasoUsoComponent>,
      private snackBar: SnackBarService,
      private spinner: NgxSpinnerService,
      private casoUsoService: CasoUsoService,
      private menuService: MenuService,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {

      this.form = this.formBuilder.group({
        Descripcion: ["", Validators.compose([Validators.required,])],
        Icono: ["", Validators.compose([Validators.required,])],
        Path: ["", Validators.compose([Validators.required])],
        Menu: ["", Validators.compose([Validators.required])],
      })
    }

    ngOnInit(): void {
      this.getAllMenus()
      this.getById(this.data.id)
    }

    getAllMenus() {
      this.spinner.show("spBusquedaMenu")
      this.menuService.getAll()
        .subscribe(
          data => {
            this.spinner.hide("spBusquedaMenu")
            this.menus = data
          },
          error => {
            this.spinner.hide("spBusquedaMenu")
            this.snackBar.showError(error, "Error");
          }
        )
    }

    getById(id:number) {
      this.spinner.show("spModificarCasoUso")
      this.casoUsoService.getById(id)
        .subscribe(
          data => {
            this.spinner.hide("spModificarCasoUso")
            this.casoUsoDto = data
            this.seteaForm(data)
          },
          error => {
            this.spinner.hide("spModificarCasoUso")
            this.snackBar.showError(error, "Error");
          }
        )
    }


    guardar() {

      let updateCasosUsoRequest: UpdateCasosUsoRequest = new UpdateCasosUsoRequest
      updateCasosUsoRequest.id = this.casoUsoDto.id
      updateCasosUsoRequest.descripcion = this.form.controls["Descripcion"].value
      updateCasosUsoRequest.icon = this.form.controls["Icono"].value.toLowerCase()
      updateCasosUsoRequest.path = this.form.controls["Path"].value.toLowerCase()
      updateCasosUsoRequest.idMenu = this.form.controls["Menu"].value
      this.update(updateCasosUsoRequest)
    }

    closeDialog() {
      this.dialogRef.close({ event: AccionesDialog.Cancelar });
    }

    update(updateCasosUsoRequest: UpdateCasosUsoRequest) {
      this.spinner.show("spModificarCasoUso")
      this.casoUsoService.update(updateCasosUsoRequest)
        .subscribe(
          data => {
            this.spinner.hide("spModificarCasoUso")
            this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
            this.dialogRef.close({ event: AccionesDialog.Modificar });
          },
          error => {
            this.spinner.hide("spModificarCasoUso")
            this.snackBar.showError(error, "Error");
          }
        )
    }

    seteaForm(casoUsoDto: CasoUsoDto) {
      this.form.controls["Descripcion"].setValue(casoUsoDto.descripcion)
      this.form.controls["Icono"].setValue(casoUsoDto.icon)
      this.form.controls["Path"].setValue(casoUsoDto.path)
      this.form.controls["Menu"].setValue(casoUsoDto.menu.id)
    }

    isFalsy(valor: any) {
      return isFalsy(valor)
    }

    trackByItems(index: number, item: any): any { return item; }
}
